export function IncidentListLoadingPlaceholder() {
  return (
    <div className="list-group list-group-flush">
      <div className="placeholder-glow list-group-item bg-transparent">
        <div className="placeholder col-6"></div>
        <div className="placeholder col-8"></div>
        <div className="placeholder col-4"></div>
      </div>
    </div>
  );
}

export function CallNotificationsListItemPlaceholder() {
  return <IncidentListLoadingPlaceholder />;
}
